// ChangeOS lockup — sibling of the ProjectPlanOS mark: same rounded-rect geometry, same aqua bar.
export function Mark({ size = 28, bar = "var(--brand-aqua)", className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} role="img" aria-label="ChangeOS">
      <rect x="4" y="1" width="5" height="30" rx="2.5" fill="currentColor" />
      <rect x="4" y="3" width="17" height="5" rx="2.5" fill="currentColor" />
      <rect x="4" y="24" width="17" height="5" rx="2.5" fill="currentColor" />
      <rect x="12" y="13.5" width="19" height="5" rx="2.5" fill={bar} />
    </svg>
  );
}

export function Lockup({ height = 24, bar = "var(--brand-aqua)", className = "", sub = false }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} data-testid="brand-lockup">
      <Mark size={height + 4} bar={bar} />
      <span className="font-head font-bold tracking-tight leading-none" style={{ fontSize: height }}>
        Change<span className="opacity-60">OS</span>
      </span>
      {sub && <span className="hidden sm:inline text-[10px] uppercase tracking-[0.14em] opacity-80 ml-1 mt-1">by ProjectPlanOS</span>}
    </span>
  );
}
